
export const PRODUCT_OVERVIEW_CONFIG = {
    PRODUCT_TARGETS: (id) => ({
      endPoint: 'product/' + id,
      // mockData: productOverviewData,
      baseUrlKey: 'inventoryApiUrl', // Dynamically use INVENTORY_API_URL
    }),
  }
  